var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41398 7.99998L15.7071 1.70758C16.0977 1.31694 16.0977 0.683589 15.7071 0.29298C15.3164 -0.09766 14.6831 -0.09766 14.2925 0.29298L8.00004 6.58603L1.70764 0.29298C1.317 -0.09766 0.68365 -0.09766 0.293041 0.29298C-0.0975678 0.68362 -0.097599 1.31697 0.293041 1.70758L6.5861 7.99998L0.293041 14.2924C-0.097599 14.683 -0.097599 15.3164 0.293041 15.707C0.683681 16.0976 1.31703 16.0976 1.70764 15.707L8.00004 9.41392L14.2924 15.707C14.6831 16.0976 15.3164 16.0976 15.707 15.707C16.0977 15.3164 16.0977 14.683 15.707 14.2924L9.41398 7.99998Z",
    fill: "white",
    fillOpacity: 0.83
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseMenu);
export default __webpack_public_path__ + "static/media/closeMenu.f77689905b32bcdbeb07066000bb190b.svg";
export { ForwardRef as ReactComponent };